/**
 * Met a jour le Consent Mode v2 (par defaut "denied", voir layout/theme.liquid)
 * a partir des choix collectes par la banniere de confidentialite NATIVE de
 * Shopify (Admin > Parametres > Confidentialite client > Banniere de
 * consentement -- a activer cote Admin, ce fichier ne cree aucune interface).
 *
 * Deux APIs Shopify distinctes, formes differentes :
 *   - evenement document 'visitorConsentCollected' : cle en camelCase +
 *     booleens (marketingAllowed, analyticsAllowed...), ne se declenche
 *     QUE quand le choix change (jamais a l'ajout de l'ecouteur).
 *   - window.Shopify.customerPrivacy.currentVisitorConsent() : cle en
 *     snake_case + chaines 'yes'/'no'/'' (vide = pas encore de choix).
 * (verifie sur shopify.dev/docs/api/customer-privacy, les deux formes ne
 * sont pas interchangeables).
 *
 * window.Shopify.customerPrivacy N'EST PAS injecte automatiquement par le
 * simple fait d'activer la banniere dans l'Admin -- verifie en direct sur
 * le dev store (banniere bien affichee, mais window.Shopify.customerPrivacy
 * absent tant que ceci n'a pas tourne). Il faut explicitement demander la
 * feature via window.Shopify.loadFeatures() ; elle n'existe qu'une fois son
 * callback execute sans erreur (voir bootstrapCustomerPrivacy ci-dessous).
 */
(function () {
  function pushConsentUpdate(marketing, analytics) {
    window.dataLayer = window.dataLayer || [];
    var marketingState = marketing ? 'granted' : 'denied';
    var update = {
      ad_storage: marketingState,
      ad_user_data: marketingState,
      ad_personalization: marketingState,
      analytics_storage: analytics ? 'granted' : 'denied'
    };
    if (typeof window.gtag === 'function') {
      window.gtag('consent', 'update', update);
    } else {
      window.dataLayer.push(['consent', 'update', update]);
    }
  }

  document.addEventListener('visitorConsentCollected', function (event) {
    var detail = event.detail || {};
    pushConsentUpdate(!!detail.marketingAllowed, !!detail.analyticsAllowed);
  });

  /* Visiteur revenant avec un choix deja fait lors d'une visite precedente
     (cookie de consentement deja pose) : sans ce rattrapage au chargement,
     seul un NOUVEAU choix dans la session courante mettrait a jour le
     consentement -- un choix deja enregistre resterait bloque sur "denied"
     par defaut tant que visitorConsentCollected ne se redeclenche pas. */
  function applyStoredConsent() {
    var current = window.Shopify.customerPrivacy.currentVisitorConsent();
    pushConsentUpdate(current.marketing === 'yes', current.analytics === 'yes');
  }

  function bootstrapCustomerPrivacy() {
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      if (error) return;
      applyStoredConsent();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrapCustomerPrivacy);
  } else {
    bootstrapCustomerPrivacy();
  }
})();
